import { useEffect, useState } from 'react';

import { CircleAlertIcon } from 'lucide-react';

export function campaignDateMs(value) {
  return typeof value === 'string'
    ? new Date(value.replace(' ', 'T')).getTime()
    : NaN;
}

export default function CampaignCountdown({
  closeDate,
  countdownStartDate,
  onExpire,
}) {
  const [msRemaining, setMsRemaining] = useState(null);

  useEffect(() => {
    const targetMs = campaignDateMs(closeDate);
    const parsedStartMs = campaignDateMs(countdownStartDate);
    // A missing countdown window must not prevent deadline enforcement.
    const startMs = Number.isFinite(parsedStartMs)
      ? parsedStartMs
      : targetMs - 60 * 60 * 1000;
    let timer;
    let expired = false;

    function evaluate() {
      clearTimeout(timer);
      const remaining = targetMs - Date.now();
      if (!Number.isFinite(targetMs) || remaining <= 0) {
        setMsRemaining(null);
        if (!expired) {
          expired = true;
          onExpire();
        }
        return;
      }

      const beforeWindow = Date.now() < startMs;
      setMsRemaining(beforeWindow ? null : remaining);
      // Bound sleeps, including dates more than the browser timeout limit away.
      timer = setTimeout(
        evaluate,
        beforeWindow
          ? Math.min(startMs - Date.now(), remaining, 60_000)
          : Math.min(remaining, 1000),
      );
    }

    const onVisible = () => {
      if (document.visibilityState === 'visible') evaluate();
    };
    evaluate();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', evaluate);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', evaluate);
    };
  }, [closeDate, countdownStartDate, onExpire]);

  if (msRemaining === null || msRemaining <= 0) return null;

  const totalSeconds = Math.ceil(msRemaining / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const display = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <div className="mb-8 flex items-center justify-center gap-2 rounded-xl border border-portal-primary bg-portal-primary/10 p-4 text-portal-text shadow-sm">
      <CircleAlertIcon />
      <span className="font-noto-ikea-bold text-sm uppercase tracking-wide">
        A campanha fecha em:
      </span>
      <span className="font-mono text-xl font-bold">{display}</span>
    </div>
  );
}
